import React from 'react'
import { ROLE_COLUMN_INFO } from './role-guide.constants'
import { ColumnInfoCard } from './role-guide.style'

/**
 * ColumnInfo — the contents of a column-header ⓘ on the User Roles table.
 *
 * Returned as the `tooltip` of a column so it renders through the shared
 * `InfoTooltip`, i.e. the same icon, size and hover behaviour as every other
 * explanatory "i" in the portal.
 *
 * Split from the column definition so the copy can be asserted directly: MUI
 * v4 drives its tooltip through popper.js, which cannot lay out under the jsdom
 * this CRA pins, so a test can never open the real popper.
 */
export const ColumnInfo = ({ columnKey }) => {
	const info = ROLE_COLUMN_INFO[columnKey]

	// A help affordance that opens nothing is worse than no affordance.
	if (!info) return null

	return (
		<ColumnInfoCard>
			<span className="column-info-eyebrow">Column guide</span>
			<p className="column-info-title">{info.title}</p>
			<p className="column-info-description">{info.description}</p>
			{info.note && <p className="column-info-note">{info.note}</p>}
		</ColumnInfoCard>
	)
}

/**
 * The value a column definition should put on its `tooltip` key. Returns
 * `undefined` — not an empty node — for an unknown column so `GenericTable`
 * skips the icon entirely instead of rendering one that opens nothing.
 */
export const columnTooltip = (columnKey) => (ROLE_COLUMN_INFO[columnKey] ? <ColumnInfo columnKey={columnKey} /> : undefined)
